/**
 * Configurations des upsells pour les deux flows (création et gestion).
 * Chaque upsell a :
 *  - key      : clé unique (utilisée dans shoppingCart et hubspot_product)
 *  - label    : nom affiché + nom du line item HubSpot
 *  - desc     : description courte affichée côté client
 *  - hsDesc   : description envoyée à HubSpot
 *  - price    : prix unitaire HT
 *  - unit     : symbole devise
 *  - suffix   : texte après le prix (/ an, / mois, etc.)
 *  - type     : 'toggle' ou 'quantity'
 *  - billing  : null (ponctuel), 'monthly', 'annually', etc.
 *  - sku      : UGS HubSpot (PC - xxx ou ABO - xxx)
 */

export const CREATION_UPSELLS = [
    {
        key:     'domiciliation',
        label:   'Domiciliation',
        desc:    'Domiciliez votre entreprise et bénéficiez de nombreux avantages.',
        hsDesc:  'Domiciliation du siège social à une adresse de prestige. Confidentialité, sécurité et réduction d\'impôts.',
        price:   0,
        unit:    '',
        suffix:  'Gratuit',
        type:    'toggle',
        formKey: 'form.domiciliation',
        billing: null,
        sku:     'PC - Domiciliation',
    },
    {
        key:     'bank',
        label:   'Compte bancaire Shine',
        desc:    'Nous vous mettons en relation avec le meilleur partenaire du marché.',
        hsDesc:  'Ouverture d\'un compte bancaire professionnel Shine. Obligation légale pour les sociétés commerciales.',
        price:   0,
        unit:    '',
        suffix:  'Gratuit',
        type:    'toggle',
        formKey: 'form.bank',
        billing: null,
        sku:     'PC - Shine création',
    },
    {
        key:     'bylaws_word',
        label:   'Statuts au format Word',
        desc:    'Très pratique pour modifier vos statuts sans frais supplémentaires.',
        hsDesc:  'Livraison des statuts juridiques au format Word éditable. Permet des modifications futures sans frais de rédaction.',
        price:   19.90,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.bylaws_word',
        billing: null,
        sku:     'PC - Statuts Word',
    },
    {
        key:     'register_your_trademark',
        label:   'Dépôt de marque INPI',
        desc:    'Nos avocats experts en propriété intellectuelle gèrent toutes les démarches.',
        hsDesc:  'Dépôt et protection de la marque auprès de l\'INPI par nos avocats en propriété intellectuelle. Couverture 10 ans.',
        price:   269,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.register_your_trademark',
        billing: null,
        sku:     'PC - Dépôt de marque',
    },
    {
        key:     'kbis_by_post',
        label:   'Recevoir le KBIS par courrier',
        desc:    'Conservez votre KBIS en papier pour les événements de votre entreprise.',
        hsDesc:  'Envoi postal du KBIS original. Document officiel indispensable pour les démarches administratives et bancaires.',
        price:   9.90,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.kbis_by_post',
        billing: null,
        sku:     'PC - KBIS par courrier',
    },
    {
        key:     'canvassing',
        label:   'STOP au démarchage abusif',
        desc:    'Inscription sur liste rouge pour limiter les courriers, mails et appels.',
        hsDesc:  'Inscription sur liste anti-démarchage pour la durée de vie de l\'entreprise. Limite courriers, mails et appels commerciaux.',
        price:   29.90,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.canvassing',
        billing: null,
        sku:     'PC - Anti-démarchage',
    },
    {
        key:     'logo',
        label:   'Logo pour votre entreprise',
        desc:    'Nos designers créent le logo idéal, libre d\'utilisation sur tous les supports.',
        hsDesc:  'Création d\'un logo professionnel sur-mesure. Libre de droits, utilisable sur tous les supports. 1 aller-retour inclus.',
        price:   149,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.logo',
        billing: null,
        sku:     'PC - Logo',
    },
    {
        key:     'brand_identity',
        label:   'Identité de marque & Charte graphique',
        desc:    'Cohérence de marque avec polices, couleurs et harmonie visuelle.',
        hsDesc:  'Création d\'une charte graphique complète : polices, couleurs primaires et secondaires, règles d\'usage de la marque.',
        price:   139,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.brand_identity',
        billing: null,
        sku:     'PC - Identité de marque',
    },
    {
        key:     'business_card',
        label:   'Design de vos cartes de visite',
        desc:    'Cartes de visite élégantes pour marquer les esprits.',
        hsDesc:  'Design de cartes de visite professionnelles par nos illustratrices. Format print-ready. 1 aller-retour inclus.',
        price:   99,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.business_card',
        billing: null,
        sku:     'PC - Cartes de visite',
    },
    {
        key:     'flyers',
        label:   'Design et création de vos flyers',
        desc:    'Formats adaptés pour conversion, notoriété ou visibilité.',
        hsDesc:  'Création de flyers professionnels, conseils sur les formats adaptés à vos objectifs marketing. 1 aller-retour inclus.',
        price:   99,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.flyers',
        billing: null,
        sku:     'PC - Flyers',
    },
    {
        key:     'domain_name_protection',
        label:   'Protection de votre nom de domaine',
        desc:    'Protection sur les meilleurs serveurs pour renforcer votre crédibilité en ligne.',
        hsDesc:  'Réservation et protection du nom de domaine en .fr. Hébergement sécurisé sur serveurs premium.',
        price:   199,
        unit:    '€',
        suffix:  ' HT / an',
        type:    'toggle',
        formKey: 'form.upsell.domain_name_protection',
        billing: 'annually',
        sku:     'ABO - Nom de domaine Annuel',
    },
    {
        key:     'computer_scientict',
        label:   'Accompagnement informaticien & mails',
        desc:    'Configuration de vos adresses mail professionnelles et accompagnement à distance.',
        hsDesc:  'Paramétrage des boîtes mail professionnelles et accompagnement informatique à distance. Configuration complète.',
        price:   399,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.computer_scientict',
        billing: null,
        sku:     'PC - Accompagnement informatique',
    },
    {
        key:     'mail_signature',
        label:   'Création de votre signature de mail',
        desc:    'Carte de visite digitale créée et configurée par nos graphistes.',
        hsDesc:  'Design et configuration d\'une signature de mail professionnelle. Installation sur votre poste incluse.',
        price:   99,
        unit:    '€',
        suffix:  ' HT',
        type:    'toggle',
        formKey: 'form.upsell.mail_signature',
        billing: null,
        sku:     'PC - Signature mail',
    },
];

export const GESTION_UPSELLS = [
    {
        key:     'general_meeting_gestion',
        label:   'Assemblée Générale',
        desc:    'Rédaction du procès-verbal, convocation et tenue de votre AG annuelle.',
        hsDesc:  'Rédaction du PV, convocation et tenue de l\'AG annuelle par votre expert-comptable. Obligation légale pour les sociétés.',
        price:   349,
        unit:    '€',
        suffix:  ' / an',
        type:    'toggle',
        formKey: 'form.upsell.general_meeting_gestion',
        billing: 'annually',
        sku:     'ABO - Assemblée Générale Annuel',
    },
    {
        key:     'business_plan',
        label:   'Business Plan',
        desc:    "Élaboration d'un business plan complet par votre expert-comptable.",
        hsDesc:  'Élaboration d\'un business plan complet : prévisionnel financier, étude de marché et stratégie de développement.',
        price:   249,
        unit:    '€',
        suffix:  ' (one-shot)',
        type:    'toggle',
        formKey: 'form.upsell.business_plan',
        billing: null,
        sku:     'PC - Business Plan',
    },
    {
        key:     'address_anonymization',
        label:   "Anonymisation de l'adresse du dirigeant",
        desc:    "Protection de votre adresse personnelle au Registre du Commerce — 199\u00a0€ + frais de greffe.",
        hsDesc:  'Protection de l\'adresse personnelle du dirigeant au RCS. Votre adresse ne sera plus visible publiquement sur les documents officiels.',
        price:   199,
        unit:    '€',
        suffix:  ' + frais de greffe',
        type:    'toggle',
        formKey: 'form.upsell.address_anonymization',
        billing: null,
        sku:     'PC - Anonymisation adresse dirigeant',
        extraHsProps: { frais_de_debours: 39.90, libelle_frais_de_debours: 'Frais de débours' },
    },
    {
        key:     'expert_meeting',
        label:   'Rendez-vous avec un Expert-Comptable',
        desc:    'Session de conseil personnalisée d\'une heure avec votre expert dédié.',
        hsDesc:  'Session de conseil d\'une heure avec un expert-comptable dédié. Optimisation fiscale, stratégie patrimoniale ou questions spécifiques.',
        price:   300,
        unit:    '€',
        suffix:  ' / heure',
        type:    'quantity',
        formKey: 'form.upsell.expert_meeting',
        billing: null,
        sku:     'PC - RDV Expert-Comptable',
    },
    {
        key:     'pay_slip',
        label:   'Bulletin de paie',
        desc:    'Établissement et gestion mensuelle de vos bulletins de salaire.',
        hsDesc:  'Établissement mensuel des bulletins de paie, déclarations sociales et DSN incluses. Conforme à la législation en vigueur.',
        price:   25,
        unit:    '€',
        suffix:  ' / bulletin / mois',
        type:    'quantity',
        formKey: 'form.upsell.pay_slip',
        billing: 'monthly',
        sku:     'ABO - Bulletin de paie Mensuel',
    },
];
